import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { SCROLL_TO_DURATION } from "./animation-config.js";

gsap.registerPlugin(ScrollToPlugin);

const reducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

function scrollToElement(target) {
  const y = target.getBoundingClientRect().top + window.scrollY;

  if (reducedMotion) {
    window.scrollTo(0, y);
    return;
  }

  gsap.to(window, {
    duration: SCROLL_TO_DURATION,
    ease: "power2.inOut",
    scrollTo: { y, autoKill: true },
  });
}

function initScrollTo() {
  document.addEventListener("click", (event) => {
    const link = event.target.closest("a[data-scroll-to]");

    if (!link) {
      return;
    }

    const href = link.getAttribute("href");

    if (!href || href.charAt(0) !== "#") {
      return;
    }

    const target = document.getElementById(href.slice(1));

    if (!target) {
      return;
    }

    event.preventDefault();
    scrollToElement(target);

    if (history.pushState) {
      history.pushState(null, "", href);
    }
  });
}

initScrollTo();
